// Контакты и настройки сайта. Перенесены из Airtable (таблица «Настройки»)
// в репозиторий. Правятся вручную.
export interface Settings {
  address: string
  workTime: string
  phone: string
  instagram: string
  vk: string
}

export const settings: Settings = {
  address: 'Первомайская 47',
  workTime: 'По предварительной записи',
  phone: '+375 25 939-10-73',
  instagram: 'https://www.instagram.com/irina_nails_zhlobin/',
  vk: 'https://vk.com/i.gellak',
}
